// extracted by extract-css-chunks-webpack-plugin
module.exports = {"wrap":"wrap-2cM51AWR"};